// extracted by mini-css-extract-plugin
export default {"wrap":"OG-z","subtitle":"PG-z","contentWrap":"QG-z","imgWrap":"RG-z","heading":"SG-z","copy":"TG-z"};